import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const LocationFieldContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse'
  }
}));

export const FullSizeLocationDropdown = styled(Box)(({ tab }) => ({
  width: '100%',
  display: tab === 0 ? 'block' : 'none'
}));

export const CenteredAddress = styled(Box)(({ theme, tab }) => ({
  display: tab === 1 ? 'grid' : 'none',
  width: '100%',
  gridGap: theme.spacing(2),
  gridTemplateColumns: '1fr 1fr',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr'
  }
}));

export const DeviationInputs = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(2),
  '& > div': {
    width: '48.5%'
  }
}));

export const ButtonGroup = styled(Box)(({ theme }) => ({
  margin: theme.spacing(0, 0, 0, 2),
  [theme.breakpoints.down('sm')]: {
    alignSelf: 'flex-end',
    margin: theme.spacing(0, 0, 2, 0)
  }
}));
